/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-02-14 00:00:00
 *
 *******************************************************/
import _ from 'lodash';
import React, { Component } from 'react';
import { Button, Popover, ActionList, Icon } from '@shopify/polaris';
import { MobileHorizontalDotsMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { getThemeReviewUrl } from 'src/helpers';
import { trackFSEvent } from 'src/integrations/fullStory';

type Props = {
  onChangeTemplate: Function,
  onManageTemplate: Function
};

type ComposedProps = Props & WithI18nProps;

class PopoverActionButton extends Component<ComposedProps> {
  state = {
    active: false
  };

  togglePopover = () => {
    this.setState(({ active }) => {
      return { active: !active };
    });
  };

  render() {
    const { i18n, onChangeTemplate, onManageTemplate, themes, selectedThemeId } = this.props;
    const { active } = this.state;

    const activator = (
      <div className="activator">
        <Button onClick={this.togglePopover}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <Icon source={MobileHorizontalDotsMajor} />
          </span>
        </Button>
      </div>
    );

    return (
      <Popover active={active} activator={activator} onClose={this.togglePopover}>
        <Popover.Pane>
          <ActionList
            items={[
              {
                content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.preview'),
                onAction: () => {
                  const previewUrl = getThemeReviewUrl(selectedThemeId);
                  const themeDetails = _.find(themes, { id: selectedThemeId });

                  // Track Full Story event
                  trackFSEvent('Preview theme', {
                    feature: 'SSR Theme Setup',
                    themeName: themeDetails?.name
                  });

                  window.open(previewUrl, '_blank');
                }
              },
              {
                content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.changeTemplate'),
                onAction: () => {
                  this.togglePopover();
                  onChangeTemplate();
                }
              },
              {
                content: i18n.translate('AdminHTML.ShopifyIntegration.Actions.manageTemplate'),
                onAction: () => {
                  this.togglePopover();
                  onManageTemplate();
                }
              }
            ]}
          />
        </Popover.Pane>
      </Popover>
    );
  }
}

export default withI18n()(PopoverActionButton);
